/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_AriaInputs */

const en_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy code to clipboard`)
};

const ar_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخ الكود إلى الحافظة`)
};

const bn_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোড ক্লিপবোর্ডে কপি করুন`)
};

const de_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code in die Zwischenablage kopieren`)
};

const es_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar código al portapapeles`)
};

const fr_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le code dans le presse-papiers`)
};

const pt_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar código para a área de transferência`)
};

const zh_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将代码复制到剪贴板`)
};

const tr_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodu panoya kopyala`)
};

const ru_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать код в буфер обмена`)
};

const pl_copy_aria = /** @type {(inputs: Copy_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiuj kod do schowka`)
};

/**
* | output |
* | --- |
* | "Copy code to clipboard" |
*
* @param {Copy_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const copy_aria = /** @type {((inputs?: Copy_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_copy_aria(inputs)
	if (locale === "bn") return bn_copy_aria(inputs)
	if (locale === "de") return de_copy_aria(inputs)
	if (locale === "es") return es_copy_aria(inputs)
	if (locale === "fr") return fr_copy_aria(inputs)
	if (locale === "pt") return pt_copy_aria(inputs)
	if (locale === "zh") return zh_copy_aria(inputs)
	if (locale === "tr") return tr_copy_aria(inputs)
	if (locale === "ru") return ru_copy_aria(inputs)
	if (locale === "pl") return pl_copy_aria(inputs)
	return en_copy_aria(inputs)
});